 /* eslint-disable */ 
import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { nationalities, countries } from "../assets/nationalities";
import{ useTranslation } from "react-i18next";
import api from "../api/api";
import { useAuth } from "../context/AuthContext";

const Filter = ({ show, setShow }) => {
  const [companies, setCompanies] = useState([]);
  const history = useHistory();
  const { user } = useAuth();
  
  // is super when url contains super
  const isSuper = window.location.href.includes("super");

  const { t } = useTranslation();

  // get data companies
  const fetchCompanies = async () => {  
    try {
      let typeurl = '/get-all-agency/';
      if (user.type == "supplier"){
        typeurl = '/get-all-vendor/';
      }
      const response = await api.get(typeurl);
      if (response.status === 200) {
        // Handle both possible response structures
        const companiesData = response.data.map(company => ({
          id: company.id,
          name: company.name
        }));
        setCompanies(Array.isArray(companiesData) ? companiesData : []);
      } else {
        console.error("Failed to fetch companies:", response.status);
      }
    } catch (error) {
      console.error("Error fetching companies:", error);
    }
  };

const [formData, setFormData] = useState({
    age_from: "18",
    age_to: "",
    marital_status: [],
    religion: [],
    nationality: [],
    company: [],
    experience: ''
})

const handleChange = (e) => {
  const { name, value, type, checked } = e.target;
  

  if (type === "checkbox") {
    setFormData((prevFormData) => {
      const prevValues = prevFormData[name] || [];
      if (checked) {
        return {
          ...prevFormData,
          [name]: [...prevValues, value],
        };
      } else {
        return {
          ...prevFormData,
          [name]: prevValues.filter((item) => item !== value),
        };
      }
    });
  } else {
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  }

 
};

const handleSubmit = (e) => {
  e.preventDefault()

  const params = new URLSearchParams();
  

  params.append('age_from', formData.age_from || "",);
  params.append('age_to', formData.age_to || "",);
  params.append('religion', formData.religion.join(','));
  params.append('marital_status', formData.marital_status.join(','));
  params.append('nationality', formData.nationality.join(','));
  params.append('experience', formData.experience);
  if (isSuper) {
    params.append('company', formData.company.join(','));
  }

  // history.push(`?${params.toString()}`);
  // push to the url with the existing query params
  const currentParams = new URLSearchParams(window.location.search);
  for (const [key, value] of params.entries()) {
    currentParams.set(key, value
    );
  }

  history.push({
    pathname: window.location.pathname,
    search: currentParams.toString(),
  });
}

useEffect(() => {
    setFormData({
      age_from: '18',
      age_to: '',
      marital_status: [],
      religion: [],
      nationality: [],
      company: [],
      experience: ''
    })
  }
, [show]);

useEffect(() => {
    if (isSuper) {
      fetchCompanies();
    }
  }, [isSuper, user.type]);

  return (
    <>
      <div className={`toggle-sidebar ${show ? "open-filter" : ""}`}>
        <div className="sidebar-layout-filter">
          <div className="sidebar-header">
            <h5>{t("Filter")}</h5>
            <a
              to="#"
              className="sidebar-closes"
              onClick={() => setShow(!show)}
            >
              <i className="fa-regular fa-circle-xmark" />
            </a>
          </div>
          <div className="sidebar-body">
            <form action="#" autoComplete="off" onSubmit={handleSubmit}>
              {/* Age */}
              <div className="accordion accordion-age" id="accordionAge">
                <div className="card-header-new" id="headingAge">
                  <h6 className="filter-title">
                    <Link
                      to="#"
                      className="w-100 collapsed"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseAge"
                      aria-expanded="true"
                      aria-controls="collapseAge"
                    >
                      {t("Age")}
                      <span className="float-end">
                        <i className="fa-solid fa-chevron-down" />
                      </span>
                    </Link>
                  </h6>
                </div>
                <div
                  id="collapseAge"
                  className="collapse"
                  aria-labelledby="headingAge"
                  data-bs-parent="#accordionExample4"
                >
                  <div className="card-body-chat">
                  <div className="input-block mb-3">
                      {/* <label className="form-control-label">Age</label> */}
                        {/* <input type="number" name="age" className="form-control" onChange={handleChange} value={formData.age} /> */}
                      <div className="input-group">
                        <span className="input-group-text">{t("From")}</span>
                        <input type="number" name="age_from" className="form-control" onChange={handleChange} value={formData.age_from} />
                        <span className="input-group-text">{t("To")}</span>
                        <input type="number" name="age_to" className="form-control" onChange={handleChange} value={formData.age_to} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* /Age */}

              {/* Marital Status */}
              <div className="accordion accordion-age" id="accordionMaritalStatus">
                <div className="card-header-new" id="headingMaritalStatus">
                  <h6 className="filter-title">
                    <Link
                      to="#"
                      className="w-100 collapsed"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseMaritalStatus"
                      aria-expanded="true"
                      aria-controls="collapseMaritalStatus"
                    >
                     {t("Marital Status")}
                      <span className="float-end">
                        <i className="fa-solid fa-chevron-down" />
                      </span>
                    </Link>
                  </h6>
                </div>
                <div
                  id="collapseMaritalStatus"
                  className="collapse"
                  aria-labelledby="headingMaritalStatus"
                  data-bs-parent="#accordionExample4"
                >
                  <div className="card-body-chat">
                    <div id="checkBoxes3">
                      <div className="selectBox-cont">
                        {[
                            "Single",
                            "Married",
                            "Divorced",
                            "Widowed",
                            "Separated"
                          ].map((marital_status) => (
                            <label className="custom_check w-100 text-capitalize" key={marital_status}>
                              <input
                                type="checkbox"
                                name="marital_status"
                                value={marital_status}
                                onChange={handleChange}
                                checked={formData.marital_status.includes(marital_status)}
                              />
                              <span className="checkmark" /> {t(marital_status)}
                            </label>
                          ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* /Marital Status */}

              {/* Religion */}
              <div className="accordion accordion-age" id="accordionReligion">
                <div className="card-header-new" id="headingReligion">
                  <h6 className="filter-title">
                    <Link
                      to="#"
                      className="w-100 collapsed"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseReligion"
                      aria-expanded="true"
                      aria-controls="collapseReligion"
                    >
                      {t("Religion")}
                      <span className="float-end">
                        <i className="fa-solid fa-chevron-down" />
                      </span>
                    </Link>
                  </h6>
                </div>
                <div
                  id="collapseReligion"
                  className="collapse"
                  aria-labelledby="headingReligion"
                  data-bs-parent="#accordionExample4"
                >
                  <div className="card-body-chat">
                    <div id="checkBoxes3">
                      <div className="selectBox-cont">
                        {/*Hakim i have modifyed the ONLY list here */}
                        {[
                            "Christian",
                            "Catholic",
                            "Muslim",
                            "Hindu",
                            "Buddhist",
                            "Sikh",
                            "Other"
                          ].map((religion) => (
                            <label className="custom_check w-100 text-capitalize" key={religion}>
                              <input
                                type="checkbox"
                                name="religion"
                                value={religion}
                                onChange={handleChange}
                                checked={formData.religion.includes(religion)}
                              />
                              <span className="checkmark" /> {t(religion)}
                            </label>
                          ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* /Religion */}

              {/* Nationality */}
              <div className="accordion accordion-age" id="accordionNationality">
                <div className="card-header-new" id="headingNationality">
                  <h6 className="filter-title">
                    <Link
                      to="#"
                      className="w-100 collapsed"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseNationality"
                      aria-expanded="true"
                      aria-controls="collapseNationality"
                    >
                      {t("Nationality")}
                      <span className="float-end">
                        <i className="fa-solid fa-chevron-down" />
                      </span>
                    </Link>
                  </h6>
                </div>
                <div
                  id="collapseNationality"
                  className="collapse"
                  aria-labelledby="headingNationality"
                  data-bs-parent="#accordionExample4"
                >
                  <div className="card-body-chat">
                    <div id="checkBoxes3">
                      <div className="selectBox-cont">
                        {nationalities.map((nationality) => (
                            <label className="custom_check w-100" key={nationality}>
                              <input
                                type="checkbox"
                                name="nationality"
                                value={nationality}
                                onChange={handleChange}
                                checked={formData.nationality.includes(nationality)}
                              />
                              <span className="checkmark" /> {t(nationality)}
                            </label>
                          ))}

                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* /Nationality */}

              {/* Experience */}
              <div className="accordion accordion-age" id="accordionExperience">
                <div className="card-header-new" id="headingExperience">
                  <h6 className="filter-title">
                    <Link
                      to="#"
                      className="w-100 collapsed"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseExperience"
                      aria-expanded="true"
                      aria-controls="collapseExperience"
                    >
                      {t("Experience")}
                      <span className="float-end">
                        <i className="fa-solid fa-chevron-down" />
                      </span>
                    </Link>
                  </h6>
                </div>
                <div
                  id="collapseExperience"
                  className="collapse"
                  aria-labelledby="headingExperience"
                  data-bs-parent="#accordionExample4"
                >
                  <div className="card-body-chat">
                    <div id="checkBoxes3">
                      <div className="selectBox-cont">
                        {countries.map((experience) => (
                            <label className="custom_check w-100 text-capitalize" key={experience}>
                              <input
                                type="checkbox"
                                name="experience"
                                value={experience}
                                onChange={handleChange}
                                checked={formData.experience.includes(experience)}
                              />
                              <span className="checkmark" /> {experience}
                            </label>
                          ))}
                          {/* <select name="experience" className="form-control" onChange={handleChange} value={formData.experience}>
                             <option value="yes">Yes</option>
                              <option value="no">No</option>
                          </select> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* /Experience */}

              {/* Companies */}
              {isSuper && (
                <div className="accordion accordion-age" id="accordionCompanies">
                  <div className="card-header-new" id="headingCompanies">
                    <h6 className="filter-title">
                      <Link
                        to="#"
                        className="w-100 collapsed"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseCompanies"
                        aria-expanded="true"
                        aria-controls="collapseCompanies"
                      >
                        {t("Companies")}
                        <span className="float-end">
                          <i className="fa-solid fa-chevron-down" />
                        </span>
                      </Link>
                    </h6>
                  </div>
                  <div
                    id="collapseCompanies"
                    className="collapse"
                    aria-labelledby="headingCompanies"
                    data-bs-parent="#accordionExample4"
                  >
                    <div className="card-body-chat">
                      <div id="checkBoxes3">
                        <div className="selectBox-cont">
                          {companies.map((company) => (
                            <label className="custom_check w-100 text-capitalize" key={company.id}>
                              <input
                                type="checkbox"
                                name="company"
                                value={String(company.id)}
                                onChange={handleChange}
                                checked={formData.company.includes(String(company.id))}
                              />
                              <span className="checkmark" /> {company.name }
                            </label>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {/* /Companies */}

              <button
                type="submit"
                className="d-inline-flex align-items-center justify-content-center btn w-100 btn-primary"
              >
                {t("Submit")}
              </button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Filter;
